import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n, { initI18n } from './i18n'
import VueApexCharts from 'vue3-apexcharts';
import './assets/css/uikit.css'
import './assets/css/style.css'
import './assets/css/custom.css'
// VESPROC design-system tokens (custom properties only — restyles nothing by itself)
import './assets/css/vesproc-tokens.css'
// VESPROC design-system components (.vp-* classes only — opt-in per screen)
import './assets/css/vesproc-components.css'
// SweetAlert2 dialogs restyled to the VESPROC modal/button language (global, no call-site changes)
import './assets/css/vesproc-swal.css'
// Quotation details screen (.qd-* classes only — RFQ edit view and its shared tab panels)
import './assets/css/vesproc-quotation.css'
// No need to import style-preset.css separately as its styles should be included in style.css

// Element Plus UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Import vue-files-preview
import VueFilesPreview from 'vue-files-preview'
import 'vue-files-preview/lib/style.css'

// Import our centralized API client so it's initialized before the app
import './services/apiClient'

// Import Firebase for notifications
import './plugins/firebase'

// Import global formatters plugin
import formattersPlugin from './plugins/formatters'

// Runtime feature switches (subscription is set by a super admin, off by default)
import { loadFeatureFlags } from '@/composables/useFeatureFlags'

// Make router globally available for auth service
window.router = router

// Create and mount the Vue application
const app = createApp(App)
app.use(router)
app.use(store)
app.use(i18n)
app.use(VueApexCharts);
app.use(VueFilesPreview) // Register VueFilesPreview plugin
app.use(ElementPlus)
app.use(formattersPlugin) // Register global formatters plugin

// Before first navigation: auth state, so route guards see permissions, and the UI texts,
// which come from the API rather than the bundle, and the runtime feature switches, so
// menus and route guards never flash a disabled feature. All run in parallel.
Promise.allSettled([store.dispatch('auth/checkAuth'), initI18n(), loadFeatureFlags()]).finally(() => {
  app.mount('#app')
})

// Initialize feather icons if available in window
if (window.feather) {
  window.feather.replace()
}

// Initialize feather icons when route changes
router.afterEach(() => {
  setTimeout(() => {
    if (window.feather) {
      window.feather.replace()
    }
  }, 100)
}) 